import { render, staticRenderFns } from "./partnerStyleTitle.vue?vue&type=template&id=0c4681a6&scoped=true"
import script from "./partnerStyleTitle.vue?vue&type=script&lang=js"
export * from "./partnerStyleTitle.vue?vue&type=script&lang=js"
import style0 from "./partnerStyleTitle.vue?vue&type=style&index=0&id=0c4681a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4681a6",
  null
  
)

export default component.exports